import React from 'react';
import { Box, Radio, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';

type MatrixRow = {
  matrixRowId: string;
  name: string;
  order: number;
};

type MatrixColumn = {
  matrixColumnId: string;
  name: string;
  order: number;
};

interface MatrixFieldPreviewProps {
  rows?: MatrixRow[];
  columns?: MatrixColumn[];
}

export const MatrixFieldPreview = React.memo(({ rows = [], columns = [] }: MatrixFieldPreviewProps) => {
  if (rows.length === 0 || columns.length === 0) {
    return (
      <Box p={1} bgcolor='#f5f5f5' borderRadius={4}>
        <Typography variant='body2' color='textSecondary'>
          Configure rows and columns to preview matrix
        </Typography>
      </Box>
    );
  }

  return (
    <Box overflow='auto'>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell style={{ borderBottom: 'none' }} />
            {columns.map((column) => (
              <TableCell
                key={column.matrixColumnId}
                align='center'
                style={{ borderBottom: 'none', padding: '4px 8px' }}
              >
                <Typography variant='caption' color='textSecondary'>
                  {column.name || `Column ${column.order + 1}`}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.matrixRowId}>
              <TableCell style={{ borderBottom: 'none', padding: '4px 8px' }}>
                <Typography variant='body2'>{row.name || `Row ${row.order + 1}`}</Typography>
              </TableCell>
              {columns.map((column) => (
                <TableCell
                  key={column.matrixColumnId}
                  align='center'
                  style={{ borderBottom: 'none', padding: '4px 8px' }}
                >
                  <Radio disabled size='small' />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
});
